const o=(o,t)=>o&&t?`${o}-${t}`:void 0;export{o as getTestId};
